/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Businessdescriptionwillappearhere4Inputs */

const en_businessdescriptionwillappearhere4 = /** @type {(inputs: Businessdescriptionwillappearhere4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business description will appear here...`)
};

const de_businessdescriptionwillappearhere4 = /** @type {(inputs: Businessdescriptionwillappearhere4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Unternehmensbeschreibung wird hier angezeigt…`)
};

/**
* | output |
* | --- |
* | "Business description will appear here..." |
*
* @param {Businessdescriptionwillappearhere4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const businessdescriptionwillappearhere4 = /** @type {((inputs?: Businessdescriptionwillappearhere4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Businessdescriptionwillappearhere4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_businessdescriptionwillappearhere4(inputs)
	return de_businessdescriptionwillappearhere4(inputs)
});
export { businessdescriptionwillappearhere4 as "businessDescriptionWillAppearHere" }